<template lang="pug">
  section.home
    template(v-if="isAdmin")
      UserStats
    template(v-else)
      .box--inner
         h2 Первичная настройка вашего конструктора!
         .update__title Индивидуальное обучение и помощь
         span Специалист нашей компании выполнит все нужные вам настройки, поможет установить конструктор на сайт и научит им пользоваться. Для получения услуги
          a.contacts__contact(href="https://t.me/conplus_support_bot" target="_blank")  обратитесь в техподдержку
          | .
          br
          br
          | Стоимость услуги 5.000 руб.
      hr.box__hr
      section.news-notifiers
        .news-notifier.news
          h2 Для самостоятельной настройки:
          .config_block
            a.update__title(href="https://youtube.com/@ConPlusRF" target="_blank") 1. Посмотрите обучающие видеоролики
            .config_block__text Вашему вниманию представлены короткие видеоинструкции основных настроек конструктора
          .config_block
            a.update__title(href="https://t.me/conplus_support_bot" target="_blank") 2. Обратитесь в службу техподдержки ConPlus
            .config_block__text Пишите нам в Telegram - оперативно поможем с решением любого вопроса
          .config_block
            a.update__title(href="https://t.me/constructorplus_ru" target="_blank") 3. Подключитесь к телеграм чату ConPlus
            .config_block__text В чате пользователи обсуждают функционал конструктора, кейсы его использования и другие вопросы мебельного бизнеса
      TutorialModal(ref="tutorial" title="С чего начать?")
        .tut-modal__content   
          h2 Привет!
          p Если вы впервые в личном кабинете ConPlus, изучите серию советов — они 
            strong сэкономят ваше время 
            | и 
            strong помогут получать максимум 
            | от сервиса. 
          p Личный кабинет — это настройки вашего конструктора и 
            strong центр управления заказами.
          h3 Если нет времени читать все советы
          p Переходите к настройкам в раздел 
            router-link(to="/constructors/1") «Шкаф-купе»
            |, чтобы установить свой ConPlus.
          p Если вы случайно закрыли один из советов, запустите его заново, нажав кнопку «?». Она находится перед заголовком страницы.
          p Если у вас возникли вопросы, напишите в «Службу поддержки» — контакты внизу каждой страницы.
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { mapState } from 'vuex';
import store from '@/store/store';
import OrderStats from '@/components/orders/OrderStats/OrderStats.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';
import UserStats from '@/components/admin/UserStats/UserStats.vue';
library.add(faStopwatch);

export default {
  data() {
    return {
      firstView: true
    };
  },

  computed: {
    ...mapState({
      newbie: state => state.global.newbie,
      ordersWait: state => state.orders.stats.measurement,
      ordersContract: state => state.orders.stats.contract,
      ordersProduction: state => state.orders.stats.inproduction,
      isAdmin: state => state.user.profile.isAdmin
    })
  },

  components: {
    FontAwesomeIcon,
    OrderStats,
    TutorialModal,
    UserStats
  },

  mounted() {
    this.firstView = localStorage.getItem('first');
  },

  destroyed() {
    localStorage.setItem('first', false);
  },

  beforeRouteEnter(to, from, next) {
    const { id: firmId } = store.state.user.profile;
    store.commit('startLoad');
    Promise.all([
      store.dispatch('ordersAssemblyGet', firmId),
      store.dispatch('ordersGet', firmId)
    ]).then(() => {
      store.commit('endLoad');
      next();
    });
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/core';

.home__orders {
  min-width: 200px;
  font-weight: bold;
  margin-bottom: 16px;
}

.education-popup {
  text-align: left;
  &__video {
    max-width: 100%;
    height: 350px;
  }

  &__text {
    padding-top: 30px;
  }
}

.home__tutorial {
  .btn {
    margin-right: 10px;
    white-space: nowrap;
  }
}

.news-notifiers {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 20px;
}

.news-notifier {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
}

.updates {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 18px;
}
.config_block {
  margin-bottom: 10px;
  &__text {
    padding-left: 16px;
  }
}

.update {
  display: flex;
  margin-bottom: 25px;
  flex: 1 0 auto;
  max-width: calc(50% - 32px);

  &:last-child {
    margin-bottom: 0;
  }

  &__img {
    width: 54px;
    height: 54px;
    flex-shrink: 0;
    background-color: _palette(base, secondary-light);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__icon {
    font-size: 32px;
    color: _palette(borders, base);
  }

  &__body {
    margin-left: 12px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c69b71;
    padding-bottom: 6px;
  }

  &__title {
    font-weight: bold;
  }

  &__date {
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-width: 992px) {
  .news-notifier {
    width: 100%;
  }

  .update {
    max-width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .updates {
    padding: 0;
  }
}
</style>
